import { axios } from "../services/axios";
import {
  TODAYS_INSPECTORS_INSPECTIONS,
  UPCOMING_INSPECTION,
  UPCOMING_INSPECTORS_INSPECTIONS,
  CUSTOMER_DASHBOARD_TILES,
  EXPIRATION_INSPECTION,
  CUSTOMER_DUE_INVOICES,
  CUSTOMER_PENDING_DEFICIENCIES,
  PREVIOUS_INSPECTORS_INSPECTIONS,
  DOWNLOAD_INSPECTOR_PREV_INSPECTION
} from "../constants/paths";
import {
  expirationsDTO,
  upcomingAndTodaysInspectionDTO,
  upcomingInspectionDTO,
} from "./interface/dashboard";

/**
 * upcoming inspection API call for dashboard
 * @param {upcomingInspectionDTO} data
 * @returns {Promise<any>}
 */
export const upcomingInspectionRequest = (
  data: upcomingInspectionDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${UPCOMING_INSPECTION}/${userId}`, { params: data });
};

/**
 * todays inspection API call for inspector dashboard
 * @param  userId
 * @returns {Promise<any>}
 */
export const todaysInspectorInspectionRequest = (
  data: upcomingAndTodaysInspectionDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${TODAYS_INSPECTORS_INSPECTIONS}/${userId}`, {
    params: data,
  });
};

/**
 * upcoming inspection API call for inspector dashboard
 * @param  userId
 * @returns {Promise<any>}
 */
export const upcomingInspectorInspectionRequest = (
  data: upcomingAndTodaysInspectionDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${UPCOMING_INSPECTORS_INSPECTIONS}/${userId}`, {
    params: data,
  });
};

/**
 * dashboard customer tiles count
 * @param  userId
 * @returns {Promise<any>}
 */
export const dashboardTilesCounts = (
  userId: number,
  data?: { search?: string }
): Promise<any> => {
  return axios.get(`${CUSTOMER_DASHBOARD_TILES}/${userId}`, { params: data });
};

/**
 * upcoming inspection API call for dashboard
 * @param {expirationsDTO} data
 * @returns {Promise<any>}
 */
export const expirationRequest = (
  data: expirationsDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${EXPIRATION_INSPECTION}/${userId}`, { params: data });
};

/**
 * Due invoices API call for dashboard
 * @param {expirationsDTO} data
 * @returns {Promise<any>}
 */
export const getDueInvoices = (
  data: expirationsDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${CUSTOMER_DUE_INVOICES}/${userId}`, { params: data });
};

/**
 * Pending Deficiences API call for dashboard
 * @param {expirationsDTO} data
 * @returns {Promise<any>}
 */
export const pendingDeficiences = (
  data: expirationsDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${CUSTOMER_PENDING_DEFICIENCIES}/${userId}`, {
    params: data,
  });
};

/**
 * previous inspection API call for inspector dashboard
 * @param  userId
 * @returns {Promise<any>}
 */
export const previousInspectorInspectionRequest = (
  data: upcomingAndTodaysInspectionDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${PREVIOUS_INSPECTORS_INSPECTIONS}/${userId}`, {
    params: data,
  });
};

export const exportPreviousInspectorInspectionRequest = (
  data: upcomingAndTodaysInspectionDTO,
  userId: number
): Promise<any> => {
  return axios.get(`${DOWNLOAD_INSPECTOR_PREV_INSPECTION}/${userId}`, {
    params: data,
   /*  responseType: "blob",
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    } */
  });
};
